import React from "react";

import * as Styles from "./styles";

interface Props {
  data: any;
  value: any;
  onChange: (value: string[]) => void;
}

const ToggleBtnsFarol: React.FC<Props> = ({ data, value, onChange }) => {
  const colorItem = (label: string) => {
    switch (label) {
      case "Atualizado":
        return "#4CAF50";
      case "Desatualizará":
        return "#ED6C02";
      case "Desatualizado":
        return "#F43637";
      default:
        return "#ffffff";
    }
  };
  const handleValues = (
    event: React.MouseEvent<HTMLElement>,
    newValues: string[]
  ) => {
    onChange(newValues);
  };

  return (
    <Styles.FormTag value={value} onChange={handleValues}>
      {data.map((item: any) => (
        <Styles.LabelTag
          sx={{
            outlineColor: colorItem(item.label),
            outlineWidth: "1px",
            outlineStyle: "solid",
          }}
          colorItem={colorItem(item.label)}
          value={item.value}
          key={item.value}
        >
          {/* {item.label} */}
        </Styles.LabelTag>
      ))}
    </Styles.FormTag>
  );
};

export default ToggleBtnsFarol;
